// src/pages/Moderation/UsersViolationsPage/ui/UsersViolationsTable/UsersViolationsTable.tsx
import React from 'react';
import './UsersViolationsTable.scss';

import { Loader } from 'components/Loader';
import { Pagination } from 'ui/NewPagination/Pagination';
import { NotFound } from 'ui/NotFound/NotFound';

import { GetFlagsResponse } from 'redux/reducers/moderation/types';
import { ModerationUser } from '../types';
import { UsersViolationsHeader } from './UsersViolationsHeader';
import { UsersViolationsRow } from './UsersViolationsRow';

type Props = {
  users: ModerationUser[];
  total: number;
  page: number;
  perPage: number;
  loader?: boolean;

  onRowClick?: (u: ModerationUser) => void;
  onPageChange: (p: number) => void;
  onPerPageChange: (pp: number) => void;
  flags: GetFlagsResponse | null;
};

const PER_PAGE_OPTIONS = [
  { id: '10', label: '10 / page' },
  { id: '20', label: '20 / page' },
  { id: '50', label: '50 / page' },
  { id: '100', label: '100 / page' },
];

export const UsersViolationsTable: React.FC<Props> = ({
  users,
  total,
  page,
  perPage,
  loader = false,
  onRowClick,
  onPageChange,
  flags,
}) => {
  return (
    <div className="uv-table">
      <UsersViolationsHeader />

      {loader ? (
        <div className="uv-table__state">
          <Loader />
        </div>
      ) : users.length ? (
        users.map((u) => (
          <UsersViolationsRow flags={flags} key={u.id} user={u} onClick={() => onRowClick?.(u)} />
        ))
      ) : (
        <div className="uv-table__state">
          <NotFound name="Users" />
        </div>
      )}

      {total > perPage ? (
        <div className="uv-table__footer">
          <div className="uv-table__footer-right">
            <Pagination
              page={page}
              total={total}
              perPage={perPage}
              onChange={onPageChange}
              siblingCount={1}
              boundaryCount={1}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};
